export const name = 'multilingual' as const
export const MultilingualSymbol = Symbol.for('Multilingual')
